import {buttonTheme, centerText, datePickerTheme} from '../components/themes.js'
import React from 'react';
import { Label, TextInput, Button, Flowbite, Datepicker, FileInput} from 'flowbite-react';
import Footer  from '../components/Footer';

export default function AddPayment() {
  return (
  
    <div className="flex flex-col gap-[20px] box-container">
        <h1 className="text-3xl font-bold">Add Payment Method</h1>

    <div>
      <Label value="Card Number"></Label>
      <TextInput id="first-name" shadow required />
    </div>
    <div className='flex m-2 gap-5'>
      <div>
        <Label value="Expiration"></Label>
        <TextInput id="expiration" shadow required />
      </div>
      <div>
        <Label value="CVC"></Label>
        <TextInput id="cvc" shadow required />
      </div>
    </div>
    <Flowbite theme={{ theme: buttonTheme }}>
        <Button color="primary" className='w-full' type='submit'>Save Payment Information</Button>
    </Flowbite>

    <Footer/>
  </div>
  )
}

